import React, { Component } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PagesEnum } from "../../constants/pagesEnum";
import CashWithdraw from "../../components/CashWithdraw";
import { useWrapperRouters } from "../../hook/wrapperRoutersHook";
import { useCashdesk } from "../../hook/cashdeskHook";
import { getRetailerId } from "../../../aaone/configuration";
import { listMovementsService } from "../../../services/cashdeskService";
import { formatDateHelper } from "../../helpers/formatDateHelper";
import { MessageBox } from "../../components/modules";
import { getPaymentsMethodService } from "../../../services/getPaymentsMethodService";
import { useAuth } from "../../hook/authHook";
import { movementsEnum } from "../../constants/movementsEnum";
import { KeyboardProvider } from "../../contexts/KeyboardContext";
import { useDialog } from "../../hook/dialogHook";
import { useLoading } from "../../hook/loadingHook";
import {
  handlePrintChargeback,
  handlePrintCoupon,
} from "../../helpers/printer/withdraw";
import { getAPIPayments } from "../../../services/paymentService";
import { getCloseCashDeskValues } from "../../../services/orderService";
import PanelStatusPdvContainer from "../../components/panel-status-pdv";
import { openDrawer } from "../../helpers/openDrawer";

const withHooks = (Component) => {
  return (props) => {
    const { setVisibleSidebarCart } = useWrapperRouters();
    const navigate = useNavigate();
    const cashdesk = useCashdesk();
    const location = useLocation();
    const dialog = useDialog();
    const loading = useLoading();
    const auth = useAuth();

    return (
      <Component
        {...props}
        setVisibleSidebarCart={setVisibleSidebarCart}
        navigate={navigate}
        cashdesk={cashdesk}
        location={location}
        dialog={dialog}
        loading={loading}
        auth={auth}
      />
    );
  };
};

export class CashCloseWithdrawContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      controlNumber: 0,
      openCard: true,
      openCardList: false,
      listWithdraw: [],
      movements: {},
      message: false,
      paymentType: null,
      manager: {},
      operator: {},
      cashdesk: this.props.cashdesk.cashdesk || null,
    };
  }

  componentDidMount() {
    this.props.setVisibleSidebarCart(false);
    if (!this.props.cashdesk.isCashdeskOnCurrentDay) {
      // TODO: Customizar alerta
      this.props.dialog.showAlert({
        message:
          "Para realizar essa operação, realize o fechamento do caixa e encerramento do dia anterior.",
      });

      // Ele não transferia a página, tive que colocar um timeout
      setTimeout(() => {
        this.props.navigate(PagesEnum.HOME);
      }, 300);

      return;
    }
    try {
      this.props.loading.setShowLoading(true);
      const { state } = this.props.location;

      const manager = state?.auth
        ? state.auth.user
        : this.props.auth.userAuthData;
      const operator = this.props.auth.userAuthData;

      const promises = [];

      promises.push(
        listMovementsService({
          retailerId: getRetailerId(),
          movementType: movementsEnum.WITHDRAW,
          initialDate: formatDateHelper(new Date(), "yyyy-MM-dd"),
          finalDate: formatDateHelper(new Date(), "yyyy-MM-dd"),
        }).then((res) => {
          const withdraws = res.filter(
            (movement) =>
              movement.openingCount ===
              this.props.cashdesk.cashdesk.openingCount
          );

          this.setState({
            controlNumber: res.length
              ? res[res.length - 1].referenceSequence + 1
              : 1,
            listWithdraw: withdraws,
          });
        })
      );

      promises.push(
        getPaymentsMethodService().then((res) => {
          this.setState({
            paymentType: res.find(
              (payment) => payment.paymentOneBaseCode === 1
            ),
          });
        })
      );

      this.setState({
        manager,
        operator,
      });
      Promise.all(promises).then(() => {
        this.props.loading.setShowLoading(false);
      });
    } catch (error) {
      console.error(error);
      this.props.loading.setShowLoading(false);
    }
  }

  handleClick(amount, description, numberEnvelop) {
    try {
      this.props.loading.setShowLoading(true);
      const req = {
        description: description,
        amount: -amount,
        numberEnvelop: numberEnvelop,
        operatorName: this.state.operator.login,
        adminName: this.state.manager.login,
        paymentType: {
          id: this.state.paymentType?.nuuidOne,
          name: this.state.paymentType?.transactionType,
          referenceId: this.state.paymentType?.paymentOneBaseCode,
        },
        responsableId: this.state.manager.nuuidOne,
        userId: this.state.operator.nuuidOne,
        responsableReferenceId: this.state.manager.employeeCode,
        userReferenceId: this.state.operator.employeeCode,
      };

      if (amount > 0) {
        this.props.cashdesk
          .cashWithdraw(req)
          .then((res) => {
            this.handlePrinter({
              cashdesk: res,
            });
            this.handleReduceCashdesk();
            this.setState({
              disableConfirm: false,
            });
            this.props.loading.setShowLoading(false);
          })
          .catch((err) => {
            console.error(err);
            this.setState({
              disableConfirm: false,
            });
            this.props.loading.setShowLoading(false);
          });
      } else {
        this.props.loading.setShowLoading(false);
        this.props.dialog.showAlert({
          message: (
            <>
              O valor informado para sangria foi R$0,00. Deseja realizar a
              redução sem informar o valor para sangria?
            </>
          ),
          onConfirmText: "Sim",
          cancelText: "Não",
          handleCancel: () => {},
          handleConfirm: () => {
            this.props.loading.setShowLoading(true);

            this.handleReduceCashdesk();
            this.setState({
              disableConfirm: false,
            });
          },
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        disableConfirm: false,
      });
      this.props.loading.setShowLoading(false);
    }
  }

  handleReduceCashdesk() {
    try {
      this.props.loading.setShowLoading(true);
      const body = {
        amout: this.state.amount,
        userId: this.state.operator.nuuidOne,
        user: this.state.operator.name,
        responsableId: this.state.manager.nuuidOne,
        responsable: this.state.manager.name,
      };

      this.props.cashdesk.cashdeskReduce(body).then((cashdesk) => {
        this.handleClose();

        //Abre a gaveta
        openDrawer();

        this.props.loading.setShowLoading(false);
      });
    } catch (err) {
      console.error(err);
      this.props.loading.setShowLoading(false);
    }
  }

  handleChargeback(itemMovement) {
    try {
      this.props.loading.setShowLoading(true);
      this.props.cashdesk
        .chargeback({
          movementId: itemMovement.id,
        })
        .then((res) => {
          this.props.dialog.showAlert({
            message: "Estorno realizado com sucesso!",
          });
          this.handlePrinter({
            cashdesk: res.cashDesk,
            movementId: itemMovement.id,
          });
          this.handleClose();
          this.props.loading.setShowLoading(false);
        });
    } catch (err) {
      console.error(err);
      this.props.loading.setShowLoading(false);
    }
  }

  onCashOutFinish() {
    this.props.cashWithdrawBoxShow(false);
    this.props.onCartShow();
  }

  handleClose() {
    this.props.navigate(PagesEnum.HOME);
    this.props.setVisibleSidebarCart();
  }

  /**
   * Função que seleciona uma data de fechamento
   * e retorna ela para o fechamento de caixa
   *
   */
  onHandleSelectClosingDate = (selectedCashdesk) => {
    if (!selectedCashdesk.closingDate) {
      this.setState({
        cashdesk: selectedCashdesk,
      });
    }
  };

  handleHidden(expandCardList) {
    const objState = {
      openCardList: expandCardList,
      openCard: !expandCardList,
    };
    this.setState(objState);
  }

  confirmChargeback = (itemMovement) => {
    this.setState({
      ...this.state,
      message: true,
      itemMovement: itemMovement,
    });
  };

  closeModal = () => {
    this.setState({
      ...this.state,
      message: false,
    });
  };

  handlePrinter({ cashdesk, movementId }) {
    const currWithdraw = movementId
      ? cashdesk.movements.filter((movement) => movement.id === movementId)[0]
      : cashdesk.movements[cashdesk.movements.length - 1];

    if (!currWithdraw.isReversed) {
      handlePrintCoupon(cashdesk, currWithdraw);
      handlePrintCoupon(cashdesk, currWithdraw);
    } else {
      handlePrintChargeback(cashdesk, currWithdraw);
    }
  }

  render() {
    // Se o caixa estiver no dia anterior
    if (!this.props.cashdesk.isCashdeskOnCurrentDay) {
      return <></>;
    }

    const { openCard, openCardList, cashdesk } = this.state;

    const messageBox = this.state.message && (
      <MessageBox
        message="Deseja realmente estornar sangria?"
        handleCancel={() => this.closeModal()}
        handleConfirm={() => this.handleChargeback(this.state.itemMovement)}
        okText="Sim"
      />
    );

    return (
      <KeyboardProvider>
        <CashWithdraw
          title="SANGRIA/REDUÇÃO DE CAIXA"
          bypassValidation={true}
          manager={this.state.manager}
          handleClick={(amount, description, numberEnvelop) =>
            this.handleClick(amount, description, numberEnvelop)
          }
          handleClose={() => this.handleClose()}
          handleHidden={(isCardList) => this.handleHidden(isCardList)}
          handlePrinter={(movementId) =>
            this.handlePrinter({
              cashdesk,
              movementId,
            })
          }
          handleChargeback={(itemMovement) =>
            this.confirmChargeback(itemMovement)
          }
          expandCard={openCard}
          expandCardList={openCardList}
          listWithdraw={this.state.listWithdraw}
          controlNumber={this.state.controlNumber}
          setVisibleSideKeyboardContainer={(visible) =>
            this.props.setVisibleSideKeyboardContainer(visible)
          }
          setVisibleBottomKeyboardContainer={(visible) =>
            this.props.setVisibleBottomKeyboardContainer(visible)
          }
        />
        {messageBox}
      </KeyboardProvider>
    );
  }
}

export default withHooks(CashCloseWithdrawContainer);
